import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
    PatientIdentityVerificator: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1rem',
    },
}))
